import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import cropService from '../../services/crop.service';
import Toast from '../../components/Toast/Toast';
import '../../styles/AddPages.css';

const AddCrop = () => {
  const navigate = useNavigate();
  const { isSuperAdmin } = useAuth();
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setError('Crop name is required'); return; }
    setIsSubmitting(true);
    try {
      const payload = { name: name.trim() };
      if (isSuperAdmin) {
        const cid = localStorage.getItem('selectedCompanyId');
        if (!cid) { setToast({ message: 'Select a company first', type: 'error' }); setIsSubmitting(false); return; }
        payload.companyId = parseInt(cid);
      }
      const res = await cropService.createCrop(payload);
      if (res.success) {
        setToast({ message: 'Crop added successfully!', type: 'success' });
        setTimeout(() => navigate('/crop/view'), 1000);
      }
    } catch (err) {
      setToast({ message: err.response?.data?.message || 'Failed to add crop', type: 'error' });
    } finally { setIsSubmitting(false); }
  };

  return (
    <div className="add-crop-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <div className="page-header"><h4 className="page-title">Add New Crop</h4></div>
      <div className="form-card">
        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Crop Name <span className="required">*</span></label>
                <input type="text" className={`form-input ${error ? 'error' : ''}`}
                  value={name}
                  onChange={(e) => { setName(e.target.value); setError(''); }}
                  placeholder="e.g. Wheat" />
                {error && <span className="error-message">{error}</span>}
              </div>
            </div>
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={() => navigate('/crop/view')} disabled={isSubmitting}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Adding...' : 'Add Crop'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCrop;